'use strict';

var _ = require('lodash');
var SearchResultMarketsService = function SearchResultMarketsService(currentStateCriteriaService, configurationService) {
  function switchField(searchFieldName) {
    return searchFieldName === 'custom:market' ? 'market' : searchFieldName;
  }
  function getInclusiveMarkets(allMarkets, values, fieldName) {
    return _.filter(allMarkets, function (item) {
      return _.indexOf(values, item[fieldName]) !== -1;
    });
  }
  function getExclusiveMarkets(allMarkets, values, fieldName) {
    return _.filter(allMarkets, function (item) {
      return _.indexOf(values, item[fieldName]) === -1;
    });
  }
  function getAllMarkets() {
    return _.map(configurationService.getMarkets(), function (item) {
      return {
        market: item.origin + '-' + item.destination,
        origin: item.origin,
        destination: item.destination
      };
    });
  }
  function getMarkets() {
    var criteria = currentStateCriteriaService.getSearchCriteria();
    var searchRule = criteria.rules && criteria.rules.length === 1 ? criteria.rules[0] : {};
    var allMarkets = getAllMarkets();
    var result = [];
    if (_.isEmpty(searchRule)) {
      return result;
    }
    var field = switchField(searchRule.field);
    if (searchRule.operator === '=') {
      result = getInclusiveMarkets(allMarkets, searchRule.leftOperand, field);
    } else {
      result = getExclusiveMarkets(allMarkets, searchRule.leftOperand, field);
    }
    return _.chain(result).sortBy('market').map(function (item) {
      return {
        value: item.market
      };
    }).value();
  }
  return {
    getMarkets: getMarkets
  };
};
SearchResultMarketsService.$inject = ['CurrentStateCriteriaService', 'ConfigurationService'];
module.exports = SearchResultMarketsService;